import PropTypes from 'prop-types';

const activityServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  createWorkspaceActivity: PropTypes.func,
  createActivity: PropTypes.func,
  getActivity: PropTypes.func,
  getActivityList: PropTypes.func,
  getActivityPlugin: PropTypes.func,
  saveActivity: PropTypes.func,
  subscribeActivity: PropTypes.func,
  duplicateActivity: PropTypes.func,
  getParentActivityId: PropTypes.func,
  getRootActivityId: PropTypes.func,
});

export default activityServiceShape;
